import { Box } from '@mui/material';
import React from 'react';
import jsonStyles from '../../StylesCarnet.json';

const ImageCarnetComponent = ({
  carnetStore,
  updatePosition,
  notEdit,
  name,
  value,
}) => {
  function getStyles(id) {
    return carnetStore.activo?.[id] ?? jsonStyles[id];
  }

  const isActivo = carnetStore.stylesCarnet?.id === name;

  return (
    <Box
      // onClick={() => _onClickComponent(photo)}
      sx={[
        {
          backgroundImage: `url(${value})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          position: 'absolute',
          border: isActivo && !notEdit ? 'solid blue 1.5px' : null,
          cursor: 'pointer',
          '&:hover': notEdit
            ? null
            : {
                border: 'solid blue 1.5px',
              },
        },
        {
          display: getStyles(name).display,
          width: `${getStyles(name).width}%`,
          height:
            getStyles(name).height === 0
              ? 'auto'
              : `${getStyles(name).height}%`,
          left: `${getStyles(name).x}%`,
          top: `${getStyles(name).y}%`,
          verticalAlign: getStyles(name).textBaseline,
          backgroundColor: getStyles(name).backgroundColor,
          borderRadius: `${getStyles(name).borderRadius}px`,
          ...(!isActivo && {
            borderWidth: `${getStyles(name).borderWidth}px`,
          }),
          boxShadow: `${getStyles(name).textShadowX}px ${
            getStyles(name).textShadowY
          }px ${getStyles(name).textShadowBlur}px ${
            getStyles(name).textShadowColor
          }`,
        },
      ]}
    />
    // <Draggable
    //   disabled={true}
    //   // disabled={notEdit}
    //   bounds="parent"
    //   defaultPosition={{
    //     x: getStyles(name).x,
    //     y: getStyles(name).y,
    //   }}
    //   grid={[3, 3]}
    //   onDrag={(e, data) => updatePosition(data.x, data.y)}
    // >
    //   <Box
    //     // onClick={() => _onClickComponent(photo)}
    //     sx={[
    //       {
    //         backgroundImage: `url(${value})`,
    //         backgroundSize: 'cover',
    //         backgroundRepeat: 'no-repeat',
    //         backgroundPosition: 'center',
    //         position: 'absolute',
    //         border: isActivo ? 'solid blue 1.5px' : null,
    //         cursor: 'pointer',
    //         '&:hover': notEdit
    //           ? null
    //           : {
    //               border: 'solid blue 1.5px',
    //             },
    //       },
    //       {
    //         display: getStyles(name).display,
    //         width: `${getStyles(name).width}%`,
    //         height:
    //           getStyles(name).height === 0
    //             ? 'auto'
    //             : `${getStyles(name).height}%`,
    //         left: `${getStyles(name).x}%`,
    //         top: `${getStyles(name).y}%`,
    //         verticalAlign: getStyles(name).textBaseline,
    //         backgroundColor: getStyles(name).backgroundColor,
    //         borderRadius: `${getStyles(name).borderRadius}px`,
    //         ...(!isActivo && {
    //           borderWidth: `${getStyles(name).borderWidth}px`,
    //         }),
    //         boxShadow: `${getStyles(name).textShadowX}px ${
    //           getStyles(name).textShadowY
    //         }px ${getStyles(name).textShadowBlur}px ${
    //           getStyles(name).textShadowColor
    //         }`,
    //       },
    //     ]}
    //   />
    // </Draggable>
  );
};

export default ImageCarnetComponent;
